import React from "react";
import { Text, Dialog, DialogType, Icon, Stack } from "@fluentui/react";

export interface ErrorProps {
    content: any;
};

const Error: React.FC<ErrorProps> = props => {

    const renderContent = () => {
        if (props.content instanceof String) {
            return <Text>{props.content}</Text>;
        } else {
            return props.content;
        }
    };

    return (
        <Dialog hidden={false} dialogContentProps={{ type: DialogType.largeHeader, styles: { title: { padding: 0}}}}>
            <Stack tokens={{childrenGap: 20}} horizontalAlign="center">
                <Icon iconName="Error" style={{fontSize: 100, color: "red"}} />
                {renderContent()}
            </Stack>
        </Dialog>
    );
};

export default Error;